<template>
  <div
    class="sidebar sidebar-dark sidebar-main sidebar-expand-md"
    v-if="isShowSidebar"
  >
    <!-- Sidebar content -->
    <div class="sidebar-content">
      <!-- Main navigation -->
      <div class="card card-sidebar-mobile">
        <ul class="nav nav-sidebar" data-nav-type="accordion">
          <!-- Main -->
          <li class="nav-item-header">
            <div class="text-uppercase font-size-xs line-height-xs">MAIN</div>
            <i class="icon-menu" title="Main"></i>
          </li>
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              :class="{ active: '/' === path }"
            >
              <i class="far fa-file-alt"></i>
              <span> Tasks Management </span>
            </router-link>
          </li>
          <li class="nav-item-header">
            <div class="text-uppercase font-size-xs line-height-xs">TOOL</div>
            <i class="icon-menu" title="TOOL"></i>
          </li>
          <li class="nav-item" v-if="isAdmin">
            <router-link
              to="/export"
              class="nav-link"
              :class="{ active: '/export' === path }"
            >
              <i class="fas fa-file-export"></i>
              <span> Data Export </span>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAdmin">
            <router-link
              to="/accuracy-analytic"
              class="nav-link"
              :class="{ active: '/accuracy-analytic' === path }"
            >
              <i class="fas fa-circle-check"></i>
              <span> Accuracy Analytic </span>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAdmin">
            <router-link
              to="/team-performance"
              class="nav-link"
              :class="{ active: '/team-performance' === path }"
            >
              <i class="fas fa-users"></i>
              <span> Team Performance </span>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAdmin">
            <router-link
              to="/data-summary"
              class="nav-link"
              :class="{ active: '/data-summary' === path }"
            >
              <i class="fas fa-chart-bar"></i>
              <span> Data Summary </span>
            </router-link>
          </li>
          <template v-if="isAdmin">
            <li class="nav-item-header">
              <div class="text-uppercase font-size-xs line-height-xs">
                SETTING
              </div>
              <i class="icon-menu" title="SETTING"></i>
            </li>
            <li class="nav-item">
              <router-link
                to="/usermanagement"
                class="nav-link"
                :class="{ active: '/usermanagement' === path }"
              >
                <i class="fas fa-user-circle"></i>
                <span> User Management </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="/undeleted-pages"
                class="nav-link"
                :class="{ active: '/undeleted-pages' === path }"
              >
                <i class="fas fa-window-close"></i>
                <span> Undeleted Pages </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="/sensitive-area-keywords"
                class="nav-link"
                :class="{ active: '/sensitive-area-keywords' === path }"
              >
                <i class="fa-users fas"></i>
                <span> Sensitive Area Keywords </span>
              </router-link>
            </li>
          </template>
          <!-- <li class="nav-item" v-if="isAdmin">
                <router-link to="/category-summary" class="nav-link" :class="{ active: '/category-summary' === path }">
                <i class="fas fa-list"></i>
                <span>
                    Category Summary
                </span>
                </router-link>
            </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isShowSidebar: false
    }
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      this.isShowSidebar = newRoute.name !== 'data-editor'
    }
  },
  mounted() {
    this.isShowSidebar = this.$route.name !== 'data-editor'
  },
  computed: {
    ...mapGetters({ role: 'role', userStatus: 'userStatus' }),
    isAdmin() {
      return this.role === 'admin'
    },
    isRequestApprover() {
      return this.userStatus === 'request_approver'
    },
    path() {
      return this.$route.path
    }
    // isShowSidebar () {
    //   return false || (this.$route.name !== 'data-editor')
    // }
  }
}
</script>
